module.exports = __webpack_public_path__ + "assets/media/2.758ba40d.wav";